__turbopack_context__.v({
  "questionnaireLetter": "QuestionnaireLetterSection-module__bBlfgW__questionnaireLetter",
  "questionnaireLetter__signature": "QuestionnaireLetterSection-module__bBlfgW__questionnaireLetter__signature",
  "questionnaireLetter__signature__button": "QuestionnaireLetterSection-module__bBlfgW__questionnaireLetter__signature__button",
  "questionnaireLetter__signature__buttonHidden": "QuestionnaireLetterSection-module__bBlfgW__questionnaireLetter__signature__buttonHidden",
  "questionnaireLetter__signature__container": "QuestionnaireLetterSection-module__bBlfgW__questionnaireLetter__signature__container",
});
